import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import TextArea from "../src/components/textArea/TextArea";
import styled from "styled-components";
import Colors from "../src/constants/Colors";
import {deviceMax} from '../styles/device';
import WaveLayout from '../src/layouts/WaweLayout';
import {NavigationURLs} from "../src/functions/NavigationFunctions";
import GeneralBreadcrumb from "../src/components/breadcrumb/GeneralBreadcrumbComp";

const Gizlilik: NextPage = () => {
    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Gizlilik Sözleşmesi'}
    ];

    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Gizlilik Sözleşmesi | Pembe Panjur'}
                description={'Pembe Panjur gizlilik sözleşmesi ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false}
                        hamburgerMenuType={'black'} registerButton={true}>
                <PrivacyWrapper>
                    <TextArea className={'mobile-plr0'}>
                        <GeneralBreadcrumb items={breadcrumbItems} margin={false} colorProps={false}/>
                        <h1 className={'mobile-h2-style'}>Pembe Panjur Gizlilik Sözleşmesi</h1>
                        <p style={{fontWeight: 'bold'}}>
                            Aşağıdaki "Gizlilik Sözleşmesi", Pembe Panjur'un, kullanıcılarına sağladığı bilgi ve
                            hizmetlerin sunumuna ilişkin hükümleri düzenlemektedir. İşbu sözleşmede Pembe Panjur Web
                            Sitesi "site", bu siteye her ne surette olursa olsun bilgi veren, kullanan, giriş yapanlar
                            ve sair de "kullanıcı" olarak adlandırılacaktır. Siteye giren ya da sitedeki formları
                            dolduran her kullanıcı, "Gizlilik Sözleşmesi" ve "Üyelik Sözleşmesi"nde yer alan hükümleri
                            okumuş ve kabul etmiş sayılacaktır.
                        </p>

                        <h2 className={'desktop-mt-0'}>
                            PEMBEPANJUR.COM İNTERNET SİTESİ GİZLİLİK SÖZLEŞMESİ
                        </h2>

                        <ol>
                            <li className={'listMarkerPink'}>
                                Sitemizi ziyaret eden kullanıcılardan topladığı bilgileri her türlü analiz yapmak
                                amacıyla kullanabilir. Pembe Panjur bu bilgileri iş ortakları ile paylaşabilir. Ancak
                                e-posta ve diğer kişisel bilgiler, hiçbir iş ortağı, şirket, kurum ya da başka bir
                                kuruluşla kullanıcının izni olmaksızın paylaşılmayacaktır.
                            </li>
                            <li className={'listMarkerPink'}>
                                Pembe Panjur kayıtlı ve misafir kullanıcılarına ait e-posta, telefon numarası gibi
                                iletişim bilgilerini Sitesinde yayınlamaz, kullanıcı aksini belirtmediyse hiçbir iş
                                ortağı, şirket, kurum ya da diğer kuruluşla paylaşmaz.
                            </li>
                            <li className={'listMarkerPink'}>
                                Sitemizde, isteyerek vermediğiniz takdirde, hakkınızda kişiyi tanımlayan bilgiler
                                toplanmayacaktır (örneğin isim, adres, telefon numarası, ya da e-posta adresi) ("kişisel
                                bilgi"). Eğer siteye kişisel bilgilerinizi verirseniz, Pembe Panjur bu bilgileri,
                                gelecekte, pazarlama, pazar araştırması, satış bilgilerinin takibi ve size ulaşmak gibi
                                amaçlarla kullanmak üzere saklayacaktır. Sizden talep edilmeyen kişisel bilgileri bize
                                verdiğiniz takdirde, bu bilgileri bu sitede belirtilen şekilde kullanmamızı onaylamış
                                olmaktasınız.
                            </li>
                            <li className={'listMarkerPink'}>
                                Pembe Panjur kişisel bilgilerinizi sadece aşağıda belirtilen yasal durumlarda ve
                                yasal prosedürler çerçevesinde 3. şahıslara açar.
                                <ul style={{listStyle: 'lower-alpha'}}>
                                    <li className={'listMarkerBold'}>
                                        Yasal mercilerden bu yönde yazılı bir talep oluşması halinde
                                    </li>
                                    <li className={'listMarkerBold'}>
                                        Pembe Panjur'un mülkiyet haklarını korumak ve savunmak amacıyla
                                    </li>
                                    <li className={'listMarkerBold'}>
                                        Üyelik Sözleşmesinde kabul ettiğiniz kurallar çerçevesinde
                                    </li>
                                </ul>
                            </li>
                            <li className={'listMarkerPink'}>
                                Pembe Panjur'da kayıtlı kişisel bilgileriniz hiçbir şekilde satılmaz, kiralanmaz ya
                                da başka bir kurum ya da kuruluş ile karşılıklı değiştirilmez. Bu "Gizlilik Sözleşmesi"
                                metninde yer alan maddeler haricinde hiçbir şekilde üçüncü şahıslarla paylaşılmaz. Pembe
                                Panjur bu sözleşmede taahhüt ettiği şartları yerine getirmek için mümkün olan tüm
                                önlemleri alır.
                            </li>
                            <li className={'listMarkerPink'}>
                                Pembe Panjur tarafından toplanan bilgiler genel kullanıma açık olmayan güvenli bir
                                ortamda saklanır. Pembe Panjur, ortamdaki bilgileri korumak için her türlü endüstri
                                standardını kullanmaktadır. Ancak buna rağmen güvenlik ile ilgili konularda bir garanti
                                verememektedir.
                            </li>
                            <li className={'listMarkerPink'}>
                                Kayıt sırasında girdiğiniz kişisel bilgilerinizi istediğiniz her zaman güncelleme ve
                                değiştirme hakkınız bulunmaktadır. Pembe Panjur bu "Gizlilik Sözleşmesi" ve "Üyelik
                                Sözleşmesi"ne uymadığınız takdirde üyeliğinizi silmeye ya da askıya almaya yetkilidir.
                            </li>
                            <li className={'listMarkerPink'}>
                                İnternetin yapısı gereği bilgiler internet üzerinde yeterli güvenlik önlemleri
                                olmaksızın dolaşabilir ve yetkili olmayan kişiler tarafından alınıp kullanılabilir. Bu
                                kullanım ve kullanımdan doğacak zarar Pembe Panjur'un sorumluluğunda değildir.
                            </li>
                            <li className={'listMarkerPink'}>
                                Bazı durumlarda, şahsınıza özel olmayan bilgiler toplanabilir. Bu tip bilgilere örnek
                                olarak kullandığınız internet browser'ın türü, işletim sisteminiz, sitemize linkle ya da
                                ilanla ulaştığınız sitenin domain ismi verilebilir.
                            </li>
                            <li className={'listMarkerPink'}>
                                Sitemizi ziyaret ettiğinizde bilgisayarınıza bilgi konulabilir. Bu bilgi, bilgi
                                belirteci ("cookie") formatında ya da benzeri türden dosyada olacaktır ve bize birkaç
                                yönden yardımcı olacaktır. Örneğin, cookie'ler, siteleri ve reklamları sizin ilgi
                                alanlarınıza ve tercihlerinize göre düzenlememizi sağlayacaktır. Hemen hemen tüm
                                internet browser'larda, cookie'leri hard diskinizden silmek, yazılmasını önlemek ya da
                                kaydedilmeden önce uyarı mesajı almak için seçenekler vardır. Bu konuda daha fazla bilgi
                                için lütfen browser'ınızın yardım dosyalarına ve kullanım bilgilerine bakınız.
                            </li>
                            <li className={'listMarkerPink'}>
                                Üyelerimizle olan iletişimlerinizle ilgili sitemizden gelen bilgilendirme
                                e-postalarını almak istemiyorsanız, e-postaların altında yer alan "Bilgilendirme
                                e-postalarını almak istemiyorsanız lütfen tıklayınız." metnine tıkladığınızda e-posta
                                bildirimleri otomatik olarak durdurulacaktır.
                            </li>
                            <li className={'listMarkerPink'}>
                                Bu Web Sitesi diğer web sitelerine link vermektedir. Gizlilik Sözleşmesi sadece bu
                                Web Sitesi içerisinde geçerlidir ve diğer web sitelerini kapsamamaktadır. Bu web
                                sitesinden link ile gidilecek diğer web sitelerindeki kullanım ile ilgili o sitelere ait
                                Gizlilik Sözleşmesi ve Üyelik Sözleşmesi geçerlidir. Bu Web Sitesinden linkle gittiğiniz
                                diğer web sitelerinde o sitelere ait Gizlilik Sözleşmesi ve Üyelik Sözleşmesi
                                metinlerini bularak okumanız önerilir.
                            </li>
                            <li className={'listMarkerPink'}>
                                İlgili kişiler kişisel verilerine ilişkin haklarını kullanmak için öncelikle veri
                                sorumlusuna başvurmak zorundadırlar. Kanunun 14'üncü maddesine göre Kişisel Verileri
                                Koruma Kurulu'na doğrudan şikâyette bulunulamaz.
                            </li>
                        </ol>

                        <p style={{fontWeight: 'bold'}}>
                            Kanun uyarınca kişisel verilerinizle ilgili olarak
                        </p>

                        <ul style={{listStyle: 'lower-alpha', paddingLeft: 17}}>
                            <li className={'listMarkerBold'}>
                                Kişisel veri işlenip işlenmediğini öğrenme,
                            </li>
                            <li className={'listMarkerBold'}>
                                Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
                            </li>
                            <li className={'listMarkerBold'}>
                                Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp
                                kullanılmadığını öğrenme,
                            </li>
                            <li className={'listMarkerBold'}>
                                Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri
                                bilme,
                            </li>
                            <li className={'listMarkerBold'}>
                                Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların
                                düzeltilmesini isteme,
                            </li>
                            <li className={'listMarkerBold'}>
                                İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin
                                silinmesini veya yok edilmesini isteme,
                            </li>
                            <li className={'listMarkerBold'}>
                                (d) ve (e) bentleri uyarınca yapılan işlemlerin, kişisel verilerinizin aktarıldığı
                                üçüncü kişilere bildirilmesini isteme,
                            </li>
                            <li className={'listMarkerBold'}>
                                İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
                                suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
                            </li>
                            <li className={'listMarkerBold'}>
                                Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde
                                zararın giderilmesini talep etme haklarınızı veri sorumlusuna başvurarak
                                kullanabilirsiniz.
                            </li>
                            <li className={'listMarkerBold'}>
                                Üyeliğinizi sisteme giriş yapmadan silmek isterseniz <a href="https://www.pembepanjur.com/hesabini-sil">https://www.pembepanjur.com/hesabini-sil</a> sayfasındaki formu kullanabilirsiniz.
                            </li>
                        </ul>

                        <p style={{fontWeight: 'bold'}}>
                            Veri Sorumlusuna Başvuru Yöntemi
                        </p>

                        <ol start={14}>
                            <li className={'listMarkerPink'}>
                                Başvurunuzu Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264
                                Bakırköy / İstanbul adresine yazılı olarak; panjurbilisim@hs02.kep.tr kayıtlı elektronik
                                posta adresine kayıtlı elektronik posta adresinizi kullanarak; Güvenli elektronik imza
                                veya mobil imza ile; Sistemimizde kayıtlı bulunan elektronik posta adresinizi kullanarak
                                bilgi@pembepanjur.com adresine e-posta göndererek yapabilirsiniz.
                            </li>
                        </ol>
                        <p>
                            Başvuru yapılırken uyulması gereken usul ve esaslar hakkındaki daha detaylı bilgiye
                            Kişisel Verileri Koruma Kurumu'nun "Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
                            Tebliğ" ile ulaşabilirsiniz.
                        </p>
                        <ol start={15}>
                            <li className={'listMarkerPink'}>
                                Pembe Panjur bu metin içindeki her türlü bilgiyi değiştirme hakkını saklı tutar. Bu
                                siteyi kullanarak bu "Gizlilik Sözleşmesi"nde yapılacak her türlü düzenleme ve
                                değişiklik kullanıcı tarafından kabul edilmiş sayılır.
                            </li>
                        </ol>

                        <p style={{fontWeight: 'bold'}}>
                            <span className={'mobileBlock'}>Telefon: 0 850 558 08 08, </span>
                            <span className={'mobileBlock'}>E-posta: bilgi@pembepanjur.com, </span>
                            <span className={'mobileBlock'}>İletişim Adres: Yeşilköy Mah.
                            Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264, Bakırköy 34149 - İstanbul</span>
                        </p>


                    </TextArea>
                </PrivacyWrapper>
            </WaveLayout>
        </React.Fragment>

    )
}

const PrivacyWrapper = styled.div`
  position: relative;
  padding: 0 25px;
  margin-bottom: 44px;

  @media ${deviceMax.tablet} {
    padding: 70px 0 0 0;
    margin-bottom: 0;
  }
  
  > div {
    padding-left: 40px;
    padding-right: 40px;
  }

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    color: ${Colors.brandColor};

    @media ${deviceMax.tablet} {
      color: ${Colors.black};
      text-align: center;
      margin: 0 auto 24px;
    }
  }

  .listMarkerPink {
    &::marker {
      font-weight: bold;
      color: ${Colors.brandColor};
    }
  }

  .listMarkerBold {
    &::marker {
      font-weight: bold;
    }
  }
`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default Gizlilik;
